module.exports = __webpack_public_path__ + "static/img/time-attendance-icon-and-name.768e8a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/time-attendance-icon-and-name.png
// module id = ZKhV
// module chunks = 0